import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CurrencyCard from '../components/CurrencyCard';
import { FaSyncAlt } from 'react-icons/fa';

const ParitePage = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrencies();
    const interval = setInterval(fetchCurrencies, 5 * 60 * 1000); // 5 dakika
    return () => clearInterval(interval);
  }, []);

  const fetchCurrencies = async () => {
    try {
      const { data } = await axios.get('/api/currency?include=parities');
      const pariteler = data.filter(c => ['EURUSD=X', 'GBPUSD=X'].includes(c.code));
      console.log('Pariteler:', pariteler);
      setCurrencies(pariteler);
      setLoading(false);
    } catch (error) {
      console.error('Parite fiyatları yüklenemedi:', error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 transition-colors duration-300 ease-in-out">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Döviz Pariteleri</h1>
          <p className="text-gray-600 dark:text-gray-300 flex items-center space-x-2">
            <FaSyncAlt className="animate-spin text-primary-600 dark:text-primary-400" />
            <span>Son güncelleme: {new Date().toLocaleString('tr-TR')}</span>
            <span className="text-green-600 dark:text-green-400 font-medium animate-pulse">● Canlı</span>
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
            {currencies.map((currency) => (
              <CurrencyCard key={currency.code} currency={currency} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParitePage;
